import { Checkbox } from '@material-ui/core';
import React, { ChangeEvent, useCallback, useState } from 'react';
import TooltipOne from '../../../../../components/TooltipOne/TooltipOne.component';
import { AssessmentSessionState } from '../../../../Dashboard/Dashboard.types';
import { useStyles } from '../SessionsProcessLimits.styles';
import { ProcessLimitRow, SessionsParamatersProcessLimitsKey } from '../SessionsProcessLimits.types';
import { Prompt } from '../../../../../components/Prompt/Prompt.component';

interface ActivateProcessLimitsProps {
  isChecked: boolean;
  type: SessionsParamatersProcessLimitsKey;
  handleCheckboxChange: (type: SessionsParamatersProcessLimitsKey, value: boolean, id: string | number) => void;
  value: ProcessLimitRow;
  validation?: (row: ProcessLimitRow) => boolean;
}

export const ActivateProcessLimits: React.FC<ActivateProcessLimitsProps> = ({
  isChecked,
  type,
  value,
  handleCheckboxChange,
  validation,
}) => {
  const styles = useStyles();
  const [openConfirmation, setOpenConfirmaton] = useState<boolean>(false);
  const onCheckboxChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (type === 'isExaminerControlLimit' && value.assessmentSessionStateId !== AssessmentSessionState.New) {
        setOpenConfirmaton(true);
      }
      handleCheckboxChange(type, event.target.checked, value.examTaskGroupId);
      if (validation) {
        validation(value);
      }
    },
    [handleCheckboxChange, type, value.examTaskGroupId, isChecked],
  );

  const checkIfIsControlProcessOn =
    value.assessmentSessionStateId !== AssessmentSessionState.New &&
    type === 'isExaminerControlLimit' &&
    isChecked === false;

  const label = { inputProps: { 'aria-label': `${isChecked ? 'Wyłącz' : 'Włącz'} proces dla grupy zadań ` } };

  const checkbox = (
    <Checkbox
      {...label}
      disableRipple
      className={styles.checkbox}
      size="small"
      color={'primary'}
      checked={isChecked}
      onChange={onCheckboxChange}
      disabled={
        (value.assessmentSessionStateId !== AssessmentSessionState.New && type !== 'isExaminerControlLimit') ||
        checkIfIsControlProcessOn
      }
    />
  );

  return (
    <>
      {!isChecked ? (
        <TooltipOne title={'Wybierz'} placement="top">
          {checkbox}
        </TooltipOne>
      ) : (
        checkbox
      )}
      <Prompt
        type="confirmation"
        open={openConfirmation}
        size="sm"
        onCancel={() => {
          handleCheckboxChange('isExaminerControlLimit', true, value.examTaskGroupId);
          setOpenConfirmaton(false);
        }}
        onConfirm={() => {
          handleCheckboxChange('isExaminerControlLimit', false, value.examTaskGroupId);
          setOpenConfirmaton(false);
        }}
        cancelButtonText="ANULUJ"
        mainActionButtonText="TAK"
        mainText={<>Czy na pewno chcesz wyłączyć proces kontrolny?</>}
        subTexts={[
          {
            text: <>Wyłączenie procesu kontrolnego uniemożliwi jego ponowne włączenie.</>,
          },
        ]}
      />
    </>
  );
};
